import { CSSProperties, MouseEventHandler } from "react"
import { Palette } from "styles/theme"

import Button from "./Button"

export interface Props {
  ariaLabel?: string
  asProp?: React.ElementType
  bold?: boolean
  children?: React.ReactNode
  className?: string
  color?: keyof Palette
  disabled?: boolean
  expanded?: boolean
  href?: string
  icon?: React.ReactNode
  iconEnd?: React.ReactNode
  iconOnly?: boolean
  iconStart?: React.ReactNode
  label?: string
  loading?: boolean
  noHoverHighlight?: boolean
  noPadding?: boolean
  onClick?: MouseEventHandler<HTMLButtonElement>
  outlined?: boolean
  padded?: boolean
  raised?: boolean
  rounded?: boolean
  secondary?: boolean
  small?: boolean
  style?: CSSProperties
  title?: string
  transparent?: boolean
  type?: "button" | "reset" | "submit"
}

export interface ComponentProps extends Props {}

export default Button
